const formatParameter = (param: string) => {
  const words = param.split("-");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedWords.join(" ");
};

const getFormattedRouteEndPart = (route: string) => {
  const parts = route.split("/");
  const lastPart = parts[parts.length - 1];

  const formattedPart = formatParameter(lastPart);
  return formattedPart;
};

export default getFormattedRouteEndPart;
